<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      ref="resource"
      title="Mandats à clôturer"
      subtitle="Recherche de mandats"
      autocomplete_idHistory="warrants"
      autocomplete_field="creancier.nom_soc || mandat.ID"
      bdTable="mandat_close"
      :actions="actions"
      :fields="fields"
      :Api="Api"
    >
      <template v-slot:menu>
        <b-row class="mb-3">
          <b-col lg="12">
            <b-button
              v-if="$store.getters.isAdmin"
              variant="secondary"
              :to="{ name: 'addWarrantsPayments' }"
              class="mr-2"
              size="sm"
              icon
              title="Réceptionner des paiements"
              ><b-icon-credit-card-fill></b-icon-credit-card-fill
            ></b-button>
            <b-button
              variant="success"
              v-if="urlGoogleMaps"
              :href="urlGoogleMaps"
              target="_blank"
              size="sm"
              icon
              title="Voir la tournée sur Google Maps"
            >
              <b-icon-map></b-icon-map>
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template v-slot:cell(ID)="data">
        <b-link
          :to="{ name: 'warrantView', params: { id: data.item.ID } }"
        >
          {{ data.item.ID }}
        </b-link>
      </template>
      <template v-slot:cell(realCreancier_nom_soc)="data">
        <b-link
          :to="{ name: 'creditorView', params: { id: data.item.creancierID } }"
        >
          {{ data.item.realCreancier_nom_soc }}
        </b-link>
      </template>
      <template v-slot:cell(arrangementID)="data">
        <span
          v-if="
            data.item.arrangementIsLate == 'Yes' &&
            data.item.status == 'ouvert' &&
            data.item.arrangementID != 0
          "
        >
          <b-icon icon="exclamation-circle-fill" variant="danger"></b-icon>
        </span>
        <span
          v-else-if="
            data.item.status == 'ouvert' && data.item.arrangementID != 0
          "
        >
          <b-icon-check-circle-fill
            variant="success"
          ></b-icon-check-circle-fill>
        </span>
        <b-link
          v-if="data.item.arrangementID != 0"
          :to="{ name: 'settlement', params: { id: data.item.arrangementID } }"
        >
          {{ data.item.arrangementID }}
        </b-link>
        <span v-else>N/A</span>
      </template>
    </bd-table-list>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import warrants from "@/services/warrants.js";
import gestion from "@/services/gestion.js";
export default {
  name: "ManageClose",
  components: {
    BdTableList,
  },
  data() {
    return {
      Api: gestion.close,
      urlGoogleMaps: null,
      computeRoute: false,
      selectedWarrants: [],
      
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats en attente de paiement",
          active: true,
        },
      ],
      actions: [
        {
          label: "Éditer",
          to: "warrantEdit",
          icon: "pencil-square",
          variant: "success"
        },
      ],
      fields: [
       {
          key: "ID",
          label: "#",
          sortable: true,
          class: "text-center",
          thStyle: { width: "100px" },
        },
        {
          key: "status",
          label: "Statut",
          sortable: true,
          thStyle: { width: "100px" },
        },
        
        {
          key: "realCreancier_nom_soc",
          label: "Créancier",
          sortable: true,
          class: "text-truncate"
        },
        {
          key: "debiteur",
          label: "Débiteur",
          class: "text-truncate",
          sortable: true,
          formatter: (value, key, item) => {
            let a = "";
            if (item.nom_soc) {
              a += item.nom_soc;
            }
            if (item.nom && item.nom_soc) {
              a += " (" + item.prenom + " " + item.nom + ")";
            } else if (!item.nom_soc) {
              a += item.prenom + " " + item.nom;
            }
            return a;
          },
        },
        {
          key: "adresse",
          label: "Adresse",
          class: "text-truncate",
          sortable: true,
          formatter: (value, key, item) => {
            let a =
              item.rue1 +
              ", " +
              item.codepostal +
              " " +
              item.localite;
            if (item.pays) {
              a += " (" + item.pays + ")";
            }

            return a;
          },
        },
        {
          key: "lastNegoDate",
          label: "Der. négo",
          class: "text-center",
          thStyle: { width: "5%" },
          sortable: true,
          formatter: (value) => this.toDate(value),
        },
        {
          key: "priorite",
          label: "Priorité",
          class: "text-center",
          thStyle: { width: "5%" },
          sortable: true,
        },
        {
          key: "arrangementID",
          label: "Arr.",
          class: "text-center",
          thStyle: { width: "5%" },
          sortable: true,
        },
        {
          key: "negotiateurID",
          label: "Négo",
          class: "text-center",
          sortable: true,
          thStyle: { width: "5%" },
        },
        
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: 'text-center',
          thStyle: { width: "100px" },
        },
      ],
    };
  },
  methods: {
    deleteRoute() {
      this.$store.commit("deleteRoute");
      this.urlGoogleMaps = '';
      this.refreshRoute();
    },
    refreshRoute() {
      let routes = this.$store.getters.getRoute;
      this.$refs.resource.rows.forEach((el, index) => {
        if (routes.includes(el.ID)) {
          this.$refs.resource.rows[index]._rowVariant = "success";
        } else {
          this.$refs.resource.rows[index]._rowVariant = null;
        }
      });
    },
    selectRow(row) {
      //this.warrants[index]._rowVariant = 'success';
      this.urlGoogleMaps = null;
      const id = row.ID;
      this.$store.commit("toggleRoute", id);
      this.refreshRoute();

      //this.selectedWarrants = payload;
    },

    
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    createRoute() {
      this.computeRoute = true;
      this.urlGoogleMaps = null;
      warrants
        .routes({
          nego: this.$store.getters.getKeycloak.me.ID,
          ids: this.$store.getters.getRoute,
        })
        .then((response) => {
          console.log(response);
          if (response.statusText == "OK" && response.data.url) {
            this.urlGoogleMaps = response.data.url;
          }
          this.computeRoute = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>